export default "__VITE_ASSET__C0I8$xwc__"